<div class="drawing-stream">
  <h1>Drawing Stream</h1>
  <ul>
    <li *ngFor="let message of messages">
      {{ message | json }}
    </li>
  </ul>
</div>
